export default "<div class=\"box_enlace pt-5\">\r\n    <app-ejecutar-consulta [listaConsultas]=consultas>\r\n    </app-ejecutar-consulta>\r\n</div>\r\n";